import React, { useContext, useEffect, useState } from 'react'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { SocketContext } from '../context/SocketContext'
import { useHideMenu } from '../hooks/useHideMenu'

import { getUsuarioStorage } from '../helpers/getUsuarioStorage'


const pasarMayusculas= (ev) =>{
    ev.preventDefault();
    ev.target.defaultValue= ev.target.defaultValue.toUpperCase();
    ev.target.value= ev.target.value.toUpperCase();
}


const MySwal = withReactContent(Swal);

export const UsuariosRoles = () => {


    const sweet = ( title, html, icon ) =>{ MySwal.fire({ title, html, icon, confirmButtonColor: 'LightSeaGreen', timer: 15000  }) }
    
    const sweetConfirm = ( title, html, icon ) =>{  return MySwal.fire({ 
                                                                    title, 
                                                                    html, 
                                                                    icon, 
                                                                    confirmButtonText: 'Ok',
                                                                    confirmButtonColor: 'LightSeaGreen',  
                                                                    showCancelButton: true, 
                                                                    cancelButtonColor: '#d33',  
                                                                    cancelButtonText: 'Cancelar' 
                                                                }) 
                                                }

    useHideMenu(false);
    
    const { socket } = useContext( SocketContext );

    const [ setIsLoading ] = useState(false);
    
    
    let [usuario] = useState( getUsuarioStorage() );
    const entidad = usuario.entidad;
    
    // tabla
    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    let   [sortedBy, setSortedBy] = useState('rol');
    let   [sortDirection, setSortDirection] = useState('asc');

    const datos={
        entidad,
        search : searchTerm || '',
        page: currentPage || '',
        itemsPerPage: itemsPerPage || '',
        sortedBy: sortedBy,
        sortDirection: sortDirection,
       
    }
  
  
    useEffect(() => {
      
        async function fetchData() {
            await socket.on('lista-Roles', ( lista ) => setData( lista ))
        }

        fetchData();

        return () => {
            socket.off('lista-Roles')
        }
    }, [socket])
   
    const handleSort = async (header) => {
        
        setSortedBy(header);
        const direction= sortDirection === 'asc' ? 'desc' : 'asc'
        setSortDirection( direction );
        datos.sortedBy= header;
        datos.sortDirection= direction;

        setIsLoading(true)
        socket.emit( 'lista-Roles', datos, async ( lista ) => {
            setIsLoading(false)
            setData(lista);
        })
           
        
    }
   
    const inactivaRol = async (uidRol, accion) => {
        
        const entidad = usuario.entidad;
        if( !entidad ) return sweet('Atención!', 'Revise la infromación', 'error');
        if( entidad=== null ) return sweet('Atención!', 'Revise la infromación', 'error');

        const confirmacion = await sweetConfirm( "Atención", "Esta seguro de Activar el registro?", "warning" ).then( (result) => {
            return (result);
        })
        
        if (!confirmacion.value) return false;

        datos.uidRol= uidRol;
        datos.accion= accion;
        
        setIsLoading(true)
        socket.emit( 'inactiva-Rol', datos, ( res ) => {
            setIsLoading(false)
            console.log( res )
        })

    }

    const registraRol = async ( uidRol ) => {

        const entidad = usuario.entidad;
        if( !entidad ) return sweet('Atención!', 'Revise la información', 'error');
        if( entidad=== null ) return sweet('Atención!', 'Revise la información', 'error');

        datos.rol    = document.getElementById(`rol_${uidRol}`).value.toUpperCase();
        
        const registros = document.querySelectorAll('.registroRol');
        
        registros.forEach((elemento, index) => {
            if( elemento.value === "" ) return sweet('Atención!', 'Revise la información', 'error');
            if( elemento.value < 0    ) return sweet('Atención!', 'Revise la información', 'error');
        });

        
        setIsLoading(true)
        socket.emit( 'registra-Rol', datos, async ( res ) => {
            setIsLoading(false)
            console.log(res)
            if( res[0] === ""){
                sweet('Atención!', res[1], 'error');
            }else if( res[0] === 1){
                sweet('', res[1], 'success');
                
                registros.forEach((elemento, index) => {
                    if( elemento.type !== "checkbox" ) elemento.value = ""
                    else elemento.checked= false;
                    delete datos[elemento.id.split("_")[0]];
                })   
            }else{
                console.log(res);
            }

          

        })

        

    }

    const editaRol = async ( ev, uidRol) =>{

        const campo= ev.target.id.split("_")[0];
        const valor= ( ev.target.type === 'checkbox' ) ? ev.target.checked : ev.target.value;
        const valorAnterior= ( ev.target.type === 'checkbox' ) ? ev.target.checked : ev.target.defaultValue;
        
        
        if ( valor !== valorAnterior  ){
            
            datos.campo = campo;
            datos.valor = valor;
            datos.uidRol = uidRol;
            
            setIsLoading(true)           
            socket.emit( 'edita-Rol', datos, async ( res ) => {
                setIsLoading(false)
            
                console.log(res)
                if( res === null){
                    
                    sweet('Atención!', 'Contacte al Administrador', 'error');
                    ev.target.value = valorAnterior;
                    console.log(res)

                }else if( res[0] === ""){
                    
                    sweet('Atención!', res[1], 'error');
                    ev.target.value = valorAnterior;

                }else if( res[0] === 1){
                    
                    delete datos[campo];
                    delete datos[valor];
                    delete datos[uidRol];
                                           
                }else{
                    sweet('Atención!', 'Contacte al Administrador', 'error');
                    console.log(res);
                }
    
            })

        }

        
    }

        
    // **************************table
   
   
    useEffect(() => {
   

        socket.emit( 'lista-Roles', datos, async ( lista ) => {
            setData(lista);
        })
       
    }, [searchTerm, currentPage, itemsPerPage]);
   


    
    const handleSearch = (ev) => {
        setSearchTerm(ev.target.value);
        setCurrentPage(1); // Reset to the first page when searching
    };

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // const indexOfLastItem = currentPage * itemsPerPage;
    // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data.slice(0, itemsPerPage);

    return (
        <div>

            <div className='row'>
                <div className='col-lg-2 col-12 '>
                    <button
                        className='btn btn-success m-3'
                        data-bs-toggle="collapse" 
                        data-bs-target="#divAgregaRol"
                    >
                    Agregar Rol
                    </button> 
                    
                </div>
            </div>

            <div id='divAgregaRol'  className='row border border-info rounded shadow p-3 collapse hide'>
                <table className='table table-responsive table-striped ' width={'100%'} >
                    <thead>
                        <tr>
                            <th width={'5%'}></th>
                            <th width={'95%'}>Rol</th>
                            
                        </tr>
                    </thead>
                    <tbody   >

                        <tr>
                            
                            <td  width={'5%'}>
                                <button
                                    className='btn btn-sm btn-primary me-1'
                                    onClick={ ()=> registraRol('') }
                                > 
                                <i className='fas fa-save'></i>
                                </button> 

                            </td>
                            
                            <td width={'95%'}> 
                                <input
                                    type='text'
                                    className='form-control registroRol'
                                    id='rol_'
                                />
                            </td>

                        </tr>
                    
                    </tbody>
                </table>

            </div>

            <hr />

            <div className='row rounded shadow p-3'>

                <div className='col-12'>
                    <div className='float-start col-lg-4 col-12 pagination'>
                        <button
                            className='btn btn-sm btn-secondary m-1'
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                        {"<"}
                        </button> 
                        <button
                            className='btn btn-sm btn-secondary m-1'
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentItems.length < itemsPerPage}
                        >
                        {">"}
                        </button>
                    </div>

                    <div className=' float-end col-lg-4 col-12'>

                        <input
                            type='text'
                            placeholder='Buscar...'
                            className='form-control'
                            maxLength={20}
                            defaultValue={searchTerm}
                            onChange={ (ev) => handleSearch(ev)}
                        />

                    </div>
                
                </div>

                <div className='col-12'>
                    <table className='table table-responsive table-striped max600' width={'100%'} >
                        <thead>
                            <tr>
                                <th width={'5%'}></th>
                                <th width={'95%'} onClick={ () => handleSort('rol') } >
                                    Rol
                                    {sortedBy === 'rol' && sortDirection === 'asc' && '▲'}
                                    {sortedBy === 'rol' && sortDirection === 'desc' && '▼'}
                                </th>
                             </tr>
                        </thead>
                        
                        <tbody width={'100%'}  >

                        {
                            
                            currentItems.length === 0 
                            ?   (   <tr>
                                        <td width={'100%'} style= {{textAlign:'center'}}> No Hay Registros </td>
                                    </tr>
                                )
                            : 
                            currentItems.map((item) => (

                                <tr key={item.uidRol}>
                                    <td width={'5%'}>
                                    
                                        {   (item.indActivo=== 1) 
                                            ?(
                                                <>
                                                    <button
                                                        className='btn btn-sm btn-danger'
                                                        onClick={() => inactivaRol( item.uidRol, 0 ) }
                                                    > 
                                                        <i className='fa-solid fa-minus'></i>
                                                    </button>
                                                 
                                                </>
                                            )
                                            :(
                                                <button
                                                    className='btn btn-sm btn-success'
                                                    onClick={() => inactivaRol( item.uidRol, 1 ) }
                                                > 
                                                <i className='fa-solid fa-plus'></i>
                                                </button>
                                            )
                                        
                                        }
                                        


                                    </td>
                                    <td width={'95%'}> 
                                        <input
                                            type='text'
                                            className='form-control'
                                            id={`rol_${item.uidUrol}`}
                                            defaultValue={item.rol.toUpperCase()}
                                            maxLength={200}
                                            onBlur={ (ev) => editaRol( ev, item.uidRol ) }
                                            onChange={ (ev) => pasarMayusculas( ev ) }
                                        />
                                    </td>
                                    
                                </tr>
                            ))
                        }
                        </tbody>
                    </table>

                    <div className='pagination'>
                        <button
                            className='btn btn-sm btn-secondary m-1'
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                        {'<'}
                        </button> 
                        <button
                            className='btn btn-sm btn-secondary m-1'
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentItems.length < itemsPerPage}
                        >
                        {'>'}
                        </button>
                    </div>
                </div>

                
            </div>

                
        </div>
    )
    
}
